// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ServiceBlock_root__M8\\+a7 {
  padding-top: 40px;
}
.ServiceBlock_root__M8\\+a7 .ServiceBlock_carousel__cu\\+FS button {
  display: none;
}
.ServiceBlock_root__M8\\+a7 .ServiceBlock_carousel__cu\\+FS span {
  display: none;
}
.ServiceBlock_root__M8\\+a7 .ServiceBlock_arrow__qjVTe {
  margin: 0 20px;
  padding: 5px;
  background-color: hsla(213, 100%, 24%, 0.4);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}
.ServiceBlock_root__M8\\+a7 .ServiceBlock_arrow__qjVTe:hover {
  background-color: hsla(213, 100%, 24%, 0.8);
}

@media (max-width: 768px) {
  .ServiceBlock_root__M8\\+a7 {
    padding-top: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ServiceBlock/ServiceBlock.module.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;AAEI;EACE,aAAA;AAAN;AAGI;EACE,aAAA;AADN;AAKE;EACE,cAAA;EACA,YAAA;EACA,2CAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHJ;AAKI;EACE,2CAAA;AAHN;;AAQA;EACE;IACE,iBAAA;EALF;AACF","sourcesContent":[".root {\n  padding-top: 40px;\n\n  .carousel {\n    button {\n      display: none;\n    }\n\n    span {\n      display: none;\n    }\n  }\n\n  .arrow {\n    margin: 0 20px;\n    padding: 5px;\n    background-color: hsla(213, 100%, 24%, 0.400);\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    top: 50%;\n    transform: translateY(-50%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &:hover {\n      background-color: hsla(213, 100%, 24%, 0.800);\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .root {\n    padding-top: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ServiceBlock_root__M8+a7`,
	"carousel": `ServiceBlock_carousel__cu+FS`,
	"arrow": `ServiceBlock_arrow__qjVTe`
};
export default ___CSS_LOADER_EXPORT___;
